module.exports = __webpack_public_path__ + "img/heart.107d5fc1.svg";